(() => {
// Kampagnenseite
jQuery(document).ready(function($) {
    $(".campaignsliderinit").flickity({
        // options
        cellAlign: "left",
        contain: true,
        fullscreen: true,
        lazyLoad: 1
    });
});
"use strict";
var $c3b0ea83484ec72b$var$panels = document.querySelectorAll(".panel");
function $c3b0ea83484ec72b$var$toggleOpen() {
    this.classList.toggle("open");
}
function $c3b0ea83484ec72b$var$toggleActive(e) {
    if (e.propertyName.indexOf("flex")) this.classList.toggle("open-active");
}
// panels.forEach(function (panel) {
//   return panel.addEventListener('click', toggleOpen);
// });
// panels.forEach(function (panel) {
//   return panel.addEventListener('transitionend', toggleActive);
// });
// panels.forEach(function(panel) {
//   const background = panel.dataset.background;
//   panel.style.backgroundImage = `url('${background}')`;
// })
for(var $c3b0ea83484ec72b$var$i = 0; $c3b0ea83484ec72b$var$i < $c3b0ea83484ec72b$var$panels.length; $c3b0ea83484ec72b$var$i++)$c3b0ea83484ec72b$var$panels[$c3b0ea83484ec72b$var$i].addEventListener("click", $c3b0ea83484ec72b$var$toggleOpen);
for(var $c3b0ea83484ec72b$var$i = 0; $c3b0ea83484ec72b$var$i < $c3b0ea83484ec72b$var$panels.length; $c3b0ea83484ec72b$var$i++)$c3b0ea83484ec72b$var$panels[$c3b0ea83484ec72b$var$i].addEventListener("transitionend", $c3b0ea83484ec72b$var$toggleActive);
// for (var i = 0; i < panels.length; i++) {
//   var background = panels[i].dataset.background;
//   panels[i].style.backgroundImage = "url('".concat(background, "')");
// }
let $c3b0ea83484ec72b$var$observer = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            let lazyElement = entry.target;
            let actualImage = lazyElement.getAttribute('data-background');
            lazyElement.style.backgroundImage = `url(${actualImage})`;
            observer.unobserve(lazyElement);
        }
    });
});
document.querySelectorAll('.panel').forEach((element)=>{
    $c3b0ea83484ec72b$var$observer.observe(element);
});

})();
//# sourceMappingURL=campaign.js.map
